import SynapseStatusPage from "./SynapseStatusPage";
import { REP_ASSIST_HELP_EMAIL } from "../utils/constantFiles/constant";

function ErrorPage() {
  const mailtoHref = `mailto:${REP_ASSIST_HELP_EMAIL}?subject=${encodeURIComponent(
    "RepAssist support request",
  )}&body=${encodeURIComponent(
    "Hello,\n\nI encountered an issue while using RepAssist.\n\nThank you.",
  )}`;

  const handleRetry = () => {
    window.location.assign("/");
  };

  return (
    <SynapseStatusPage
      variant="error"
      heading="Looks like something went wrong"
      linkHref={mailtoHref}
      linkText={REP_ASSIST_HELP_EMAIL}
      linkSuffix="for assistance."
      showRetryButton
      onRetry={handleRetry}
    />
  );
}

export default ErrorPage;
